// extracted by mini-css-extract-plugin
module.exports = {"timeform":"_0b735cf","timeformVerdict":"_f38ec51"};